import IntoGuide from './IntoGuide.vue';

IntoGuide.install = (Vue) => {
  Vue.component(IntoGuide.name, IntoGuide);
};

export default IntoGuide;
